import { render, staticRenderFns } from "./facheck.vue?vue&type=template&id=72e78a06&scoped=true&"
import script from "./facheck.vue?vue&type=script&lang=js&"
export * from "./facheck.vue?vue&type=script&lang=js&"
import style0 from "./facheck.vue?vue&type=style&index=0&id=72e78a06&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e78a06",
  null
  
)

export default component.exports